import { render, staticRenderFns } from "./ResourcePanel.vue?vue&type=template&id=036fed2f&scoped=true&"
import script from "./ResourcePanel.vue?vue&type=script&lang=ts&"
export * from "./ResourcePanel.vue?vue&type=script&lang=ts&"
import style0 from "./ResourcePanel.vue?vue&type=style&index=0&id=036fed2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036fed2f",
  null
  
)

export default component.exports